import Vue from 'vue'
import Router from 'vue-router'
import ViewHome from '@/views/ViewHome/ViewHome'
import ViewDynamic from '@/views/ViewDynamic/ViewDynamic'
import ViewOrder from '@/views/ViewOrder/ViewOrder'
// const ViewHome = () => import(/* webpackChunkName: "ViewHome" */ '@/views/ViewHome/ViewHome')
// const ViewDynamic = () => import(/* webpackChunkName: "ViewDynamic" */ '@/views/ViewDynamic/ViewDynamic')
Vue.use(Router)
const routes = [
  {
    path: '/',
    name: 'ViewHome',
    component: ViewHome
  },
  {
    path: '/om-oss',
    name: 'ViewAboutUs',
    component: ViewDynamic
  },
  {
    path: '/renens-ar',
    name: 'ViewTheYear',
    component: ViewDynamic
  },
  {
    path: '/bestall-kott',
    name: 'ViewOrder',
    component: ViewOrder
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js